export default "__VITE_ASSET__CPMcN25T__"